import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

const requiredEmail = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
      .email("Invalid email")
  );

const requiredDate = (label) =>
  z.preprocess(
    (value) => {
      if (value === "" || value == null) return undefined;
      const parsed = value instanceof Date ? value : new Date(value);
      return parsed;
    },
    z.date({
      required_error: `${label} is required`,
      invalid_type_error: `${label} is required`,
    })
  );

export const Step1Schema = z.object({
  producer: requiredText("Producer"),
  agentEmail: requiredEmail("Agent email"),
  policyDate: requiredDate("Policy effective date").refine((date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + 30);
    return date <= maxDate;
  }, {
    message: "Policy Date must be between today and 30 days from today",
  }),
  insuredState: requiredText("Insured state"),
  allowedCarriers: z.array(z.string()).default([]),
  carrier: z.array(z.string()).min(1, "Please select at least one carrier"),
  quoteType: z.string().optional(),
});
